'use client'

import clsx from 'clsx'

import type { ButtonProps } from './types'

export default function Button({
	variant,
	size = 'lg',
	href,
	type = 'button',
	isExternal = false,
	disabled = false,
	className,
	children,
	...props
}: ButtonProps) {
	const finalClassName = clsx(`button-${variant}`, `button-${size}`, className)

	if (href) {
		return (
			<a
				href={href}
				target={isExternal ? '_blank' : undefined}
				rel={isExternal ? 'noopener noreferrer' : undefined}
				className={finalClassName}
				{...props}
			>
				{children}
			</a>
		)
	}

	return (
		<button type={type} disabled={disabled} className={finalClassName} {...props}>
			{children}
		</button>
	)
}
